// Panelin çalıştığı adres (2026-10-19, LGS kararı). Tek bundle iki adreste yayınlanır:
// - yks.makembed.fun: YKS paneli; LGS sekmesi yalnız super_admin'e görünür.
// - lgs.makembed.fun: LGS kipi — yalnız LGS seti. Apache aynı backend'e (/api -> :3002) aktarır;
//   API kendi adresinden çağrılır (CORS yok, oturum o adrese ayrı açılır).
export const lgsModu = (host) => /^lgs\./i.test(host || '');

export const LGS_MODU = typeof window !== 'undefined' && lgsModu(window.location.hostname);

if (LGS_MODU) document.title = 'LGS Soru Paneli';

export const API = LGS_MODU ? window.location.origin : (process.env.REACT_APP_API_URL || 'http://167.86.115.175:3002');
